import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
):
  | {
      fullName: string;
      consultations: number;
      labs: number;
      prescriptions: number;
    }[]
  | null => {
  //   console.log(res.data);
  const newData = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const { full_name, consultations, labs, prescriptions } =
        res.data.data[i];
      newData.push({
        fullName: full_name,
        consultations,
        labs,
        prescriptions,
      });
    }

    return newData;
  }

  return null;
};

interface Props extends DashboardQueryProps {
  staffType: string;
  recordType: string;
}

export const useGetTopPerformingStaff = ({
  // isEnabled = true,
  dateRange,
  startDate,
  endDate,
  limit = 10,
  staffType,
  recordType,
}: Props) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.topPerformingStaffWithFilters({
      dateRange,
      startDate,
      endDate,
      staffType,
      recordType,
      limit,
    }),
    queryFn: () => {
      return api.get("analytics/staff-activity", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          limit,
          staff_type: staffType,
          record_type: recordType,
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Frequent services]", res);
      handleErrors(res, "query");
    },
  });
};
